
    const data = {"name":"src/core/icons/basket","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M5.5 21c-.78 0-1.46-.45-1.79-1.1L1.1 10.44 1 10a1 1 0 0 1 1-1h4.58l4.6-6.57a.997.997 0 0 1 1.65.01L17.42 9H22a1 1 0 0 1 1 1l-.04.29-2.67 9.61c-.33.65-1.01 1.1-1.79 1.1h-13M12 4.74 9 9h6l-3-4.26M12 13a2 2 0 0 0-2 2 2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            